import React, { Component } from 'react'
import { Tag, Icon } from 'antd'
import { observer, inject } from 'mobx-react'

import Keyword from './Keyword'
@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class SearchItem extends Component<any, any> {
    state = {
        open: false
    }
    toggle = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { name, id, summary, synonymsStore, moreInfo } = this.props
        const keywords = summary.split(' ')
        return (
            <div
                onClick={() => this.toggle()}
                style={{ cursor: 'pointer', display: 'flex', width: '100%', flexDirection: 'column' }}
            >
                <div style={{ width: '100%', display: 'flex' }}>
                    <div style={{ width: '40%' }}>
                        <Icon type={open ? 'down' : 'left'} /> {id} - {name}
                    </div>
                    <div style={{ width: '60%', padding: '0 0.5rem' }}>
                        <strong style={{ marginLeft: '0.5rem' }}>מילים תואמות</strong>
                        {keywords.map((keyword, index) => {
                            if (keyword in synonymsStore.indexedKeywords) {
                                return <Keyword keyword={keyword} key={index} />
                            }
                        })}
                    </div>
                </div>
                {open && (
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '40%', paddingRight: '1.5rem' }}>{moreInfo}</div>
                        <div style={{ width: '60%', padding: '0 0.5rem' }}>
                            <strong>מושגים נוספים</strong>
                            {keywords.map((keyword, index) => {
                                if (!(keyword in synonymsStore.indexedKeywords)) {
                                    return <Keyword keyword={keyword} key={index} />
                                }
                            })}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default SearchItem
